import { useQuery } from "@tanstack/react-query";
import { PatientNotificationPreferenceControllerApi } from "../../services";
import { getConfigObject, useBaseContent } from "../../utils/utils";

type Notification = {
  uuid: string;
  notificationTypeId: number;
  notificationTypeName: string;
  category: string;
  push: boolean;
  text: boolean;
  email: boolean;
};

export const useGetNotificationPreferences = (patientUuid: string): useBaseContent<Notification> =>
  useQuery({
    queryKey: ["notification-preferences", patientUuid],
    refetchOnWindowFocus: false,
    enabled: !!patientUuid,
    queryFn: async () =>
      await new PatientNotificationPreferenceControllerApi(getConfigObject())
        .getPreferences(patientUuid)
        .then((res) => res?.data),
  });
